import { CountryItemModel, Region, Settlement } from '@app/pages/clinic/models/common.model';

export const COUNTRIES_LIST: CountryItemModel[] = [
  {
    id: 1,
    name: 'Albania'
  },
  {
    id: 2,
    name: 'Kosovo'
  }
];

export const REGIONS_COLLECTION: Region[] = [
  // Albania regions
  { id: 1, name: "Tiranë", countryId: 1, },
  { id: 2, name: "Durrës", countryId: 1, },
  { id: 3, name: "Elbasan", countryId: 1, },
  { id: 4, name: "Shkodër", countryId: 1, },
  { id: 5, name: "Vlorë", countryId: 1, },
  { id: 6, name: "Fier", countryId: 1, },
  { id: 7, name: "Korçë", countryId: 1, },
  { id: 8, name: "Lezhë", countryId: 1, },
  { id: 9, name: "Dibër", countryId: 1, },
  { id: 10, name: "Berat", countryId: 1, },
  { id: 11, name: "Kukës", countryId: 1, },
  // Kosovo regions
  { id: 12, name: "Gjirokastër", countryId: 1, },
  { id: 13, name: "Pristina", countryId: 2, },
  { id: 14, name: "Mitrovica", countryId: 2, },
  { id: 15, name: "Peja", countryId: 2, },
  { id: 16, name: "Gjilan", countryId: 2, },
  { id: 17, name: "Gjakova", countryId: 2, },
  { id: 18, name: "Prizren", countryId: 2, },
  { id: 19, name: "Ferizaj", countryId: 2, },
];

export const SETTLEMENT_COLLECTION: Settlement[] = [
  /* Albania settlements */
  // Qarku i Beratit (id = 10)
  { id: 1, name: "Berat", regionId: 10 },
  { id: 2, name: "Dimal", regionId: 10 },
  { id: 3, name: "Kuçovë", regionId: 10 },
  { id: 4, name: "Poliçan", regionId: 10 },
  { id: 5, name: "Skrapar", regionId: 10 },

  // Qarku i Dibrës (id = 9)
  { id: 6, name: "Bulqizë", regionId: 9 },
  { id: 7, name: "Dibër", regionId: 9 },
  { id: 8, name: "Klos", regionId: 9 },
  { id: 9, name: "Mat", regionId: 9 },

  // Qarku i Durrësit (id = 2)
  { id: 10, name: "Durrës", regionId: 2 },
  { id: 11, name: "Krujë", regionId: 2 },
  { id: 12, name: "Shijak", regionId: 2 },

  // Qarku i Elbasanit (id = 3)
  { id: 13, name: "Belsh", regionId: 3 },
  { id: 14, name: "Cërrik", regionId: 3 },
  { id: 15, name: "Elbasan", regionId: 3 },
  { id: 16, name: "Gramsh", regionId: 3 },
  { id: 17, name: "Librazhd", regionId: 3 },
  { id: 18, name: "Peqin", regionId: 3 },
  { id: 19, name: "Prrenjas", regionId: 3 },

  // Qarku i Fierit (id = 6)
  { id: 20, name: "Divjakë", regionId: 6 },
  { id: 21, name: "Fier", regionId: 6 },
  { id: 22, name: "Lushnjë", regionId: 6 },
  { id: 23, name: "Mallakastër", regionId: 6 },
  { id: 24, name: "Patos", regionId: 6 },
  { id: 25, name: "Roskovec", regionId: 6 },

  // Qarku i Gjirokastrës (id = 12)
  { id: 26, name: "Dropull", regionId: 12 },
  { id: 27, name: "Gjirokastër", regionId: 12 },
  { id: 28, name: "Këlcyrë", regionId: 12 },
  { id: 29, name: "Libohovë", regionId: 12 },
  { id: 30, name: "Memaliaj", regionId: 12 },
  { id: 31, name: "Përmet", regionId: 12 },
  { id: 32, name: "Tepelenë", regionId: 12 },

  // Qarku i Korçës (id = 7)
  { id: 33, name: "Devoll", regionId: 7 },
  { id: 34, name: "Kolonjë", regionId: 7 },
  { id: 35, name: "Korçë", regionId: 7 },
  { id: 36, name: "Maliq", regionId: 7 },
  { id: 37, name: "Pogradec", regionId: 7 },
  { id: 38, name: "Pustec", regionId: 7 },

  // Qarku i Kukësit (id = 11)
  { id: 39, name: "Has", regionId: 11 },
  { id: 40, name: "Kukës", regionId: 11 },
  { id: 41, name: "Tropojë", regionId: 11 },

  // Qarku i Lezhës (id = 8)
  { id: 42, name: "Kurbin", regionId: 8 },
  { id: 43, name: "Lezhë", regionId: 8 },
  { id: 44, name: "Mirditë", regionId: 8 },

  // Qarku i Shkodrës (id = 4)
  { id: 45, name: "Fushë-Arrëz", regionId: 4 },
  { id: 46, name: "Malësi e Madhe", regionId: 4 },
  { id: 47, name: "Pukë", regionId: 4 },
  { id: 48, name: "Shkodër", regionId: 4 },
  { id: 49, name: "Vau i Dejës", regionId: 4 },

  // Qarku i Tiranës (id = 1)
  { id: 50, name: "Kamëz", regionId: 1 },
  { id: 51, name: "Kavajë", regionId: 1 },
  { id: 52, name: "Rrogozhinë", regionId: 1 },
  { id: 53, name: "Tiranë", regionId: 1 },
  { id: 54, name: "Vorë", regionId: 1 },

  // Qarku i Vlorës (id = 5)
  { id: 55, name: "Delvinë", regionId: 5 },
  { id: 56, name: "Finiq", regionId: 5 },
  { id: 57, name: "Himarë", regionId: 5 },
  { id: 58, name: "Konispol", regionId: 5 },
  { id: 59, name: "Sarandë", regionId: 5 },
  { id: 60, name: "Selenicë", regionId: 5 },
  { id: 61, name: "Vlorë", regionId: 5 },

  /* Kosovo settlements */
  // Pristina District (regionId = 13)
  { id: 62, name: "Pristina", regionId: 13 },
  { id: 63, name: "Podujevë", regionId: 13 },
  { id: 64, name: "Drenas", regionId: 13 },
  { id: 65, name: "Lipjan", regionId: 13 },
  { id: 66, name: "Fushë Kosovë", regionId: 13 },
  { id: 67, name: "Obiliq", regionId: 13 },
  { id: 68, name: "Gračanica", regionId: 13 },
  { id: 69, name: "Artana", regionId: 13 },

  // Mitrovica District (regionId = 14)
  { id: 70, name: "Mitrovica", regionId: 14 },
  { id: 71, name: "Skenderaj", regionId: 14 },
  { id: 72, name: "Vushtrri", regionId: 14 },
  { id: 73, name: "Leposavić", regionId: 14 },
  { id: 74, name: "Zubin Potok", regionId: 14 },
  { id: 75, name: "Zvečan", regionId: 14 },

  // Peja District (regionId = 15)
  { id: 76, name: "Peja", regionId: 15 },
  { id: 77, name: "Istog", regionId: 15 },
  { id: 78, name: "Klina", regionId: 15 },

  // Gjilan District (regionId = 16)
  { id: 79, name: "Gjilan", regionId: 16 },
  { id: 80, name: "Kamenica", regionId: 16 },
  { id: 81, name: "Klokot", regionId: 16 },
  { id: 82, name: "Ranilug", regionId: 16 },
  { id: 83, name: "Viti", regionId: 16 },

  // Gjakova District (regionId = 17)
  { id: 84, name: "Gjakova", regionId: 17 },
  { id: 85, name: "Rahovec", regionId: 17 },
  { id: 86, name: "Junik", regionId: 17 },

  // Prizren District (regionId = 18)
  { id: 87, name: "Prizren", regionId: 18 },
  { id: 88, name: "Malishevë", regionId: 18 },
  { id: 89, name: "Dragash", regionId: 18 },
  { id: 90, name: "Mamusha", regionId: 18 },
  { id: 91, name: "Suharekë", regionId: 18 },

  // Ferizaj District (regionId = 19)
  { id: 92, name: "Ferizaj", regionId: 19 },
  { id: 93, name: "Kaçanik", regionId: 19 },
  { id: 94, name: "Shtime", regionId: 19 },
  { id: 95, name: "Hani i Elezit", regionId: 19 },
  { id: 96, name: "Štrpce", regionId: 19 },
];
